import { Link } from 'react-router-dom';

export function Navbar() {
  return (
    <div className="navbar">
      <nav>
        <Link className={"link-class"} to="/">Jobs Manager</Link>
        <Link className={"link-class"} to="/edit-feed">Edit Feed</Link>
        <Link className={"link-class"} to="/view-feed">Feed Viewer</Link>
      </nav>
    </div>
  )
}
